import { computed, type ComputedRef, type InjectionKey } from "vue";
import type { OrderDto } from "./gfo_api/order_api";
import type { CurrentOrderProvider } from "./current_order_provider";


export interface ConfigsNavigationPath {
  path: string;
  title: string;
}

export class ConfigsProvider {
  private currentOrderProvider: ReturnType<typeof CurrentOrderProvider>;

  constructor(currentOrderProvider: ReturnType<typeof CurrentOrderProvider>) {
    this.currentOrderProvider = currentOrderProvider;
  }

  get configsPathes(): ComputedRef<ConfigsNavigationPath[]> {
    return computed(() => {
      const types = this.allConfigsTypes.value;
      let pathes: ConfigsNavigationPath[] = [];
      if (types.some((t) => ["AccessDslConfig", "AccessFiberConfig", "FixipRipeConfig"].includes(t))) {
        pathes.push({
          path: "/configs/access",
          title: "ConfigsNavigation_Access",
        });
      }
      if (types.some((t) => t == "LandlineNewConfig" || t == "LandlinePortingConfig")) {
        pathes.push({
          path: "/configs/phone",
          title: "ConfigsNavigation_Phone",
        });
      }

      if (types.some((t) => t == "MobileNewConfig" || t == "MobilePortingConfig")) {
        pathes.push({
          path: "/configs/mobile",
          title: "ConfigsNavigation_Mobile",
        });
      }
      if (types.some((t) => t == "TvConfig")) {
        pathes.push({
          path: "/configs/tv",
          title: "ConfigsNavigation_Tv",
        });
      }
      return pathes;
    });
  }

  get allConfigsTypes(): ComputedRef<string[]> {
    return computed(() => {
      const currentOrder: OrderDto|null = this.currentOrderProvider?.currentOrder.value;
      return currentOrder?.configs.map((c) => c.type) ?? [];
    });
  }
}

// gibt bei der injection automatisch den richtigen Typ
export const configsProviderKey: InjectionKey<
  InstanceType<typeof ConfigsProvider>
> = Symbol("configs-provider");
